import { PresentationState } from "../../../../reducers/presentationSlice";
import { IAssigmentsTableData, IAssigmentsTableDataWithRequiredIds } from "../../../../types/common";
import { CompanyOfficialLogo, IAssignmentFieldsOverride, IBaseCredentialMetaData, ILogoPreferenceById, LogoPreference, PresentationSlideNumber, PresentationSlideTitle, PrivateAndConfidential } from "../../../../types/credential";
import { IProject } from "../../../../types/project";
import type pptxgen from "pptxgenjs";

export interface ISidebarContentProps {
  activeKey: MENU_KEYS;
  assignmentsTableData: IAssigmentsTableData[] | undefined;
  setActiveKey: React.Dispatch<React.SetStateAction<"preferences" | "layout" | "presentation_preview">>;
};

export const KEYS = ['preferences', 'layout', 'presentation_preview'] as const;
export type MENU_KEYS = typeof KEYS[number];

export type MENU_OPTION = {
  'text': string,
  'icon': string,
  'key': MENU_KEYS,
};

export type SidebarContentCommon = Pick<ISidebarContentProps, 'setActiveKey'>;
export interface UniquelyIdentifiedProjects extends IProject {
  id: string;
}

export type NullableIProjectArr = UniquelyIdentifiedProjects[] | undefined;
export type NullableIAssigmentsTableData = UniquelyIdentifiedAssigmentsTableData[] | undefined;
export interface UniquelyIdentifiedAssigmentsTableData extends IAssigmentsTableData {
  id: string;
}

export type PrivateAndConfidentialOption = {
  value: PrivateAndConfidential['placement'];
  label: string;
}
export type CompanyOfficialLogoOption = {
  value: CompanyOfficialLogo['placement'];
  label: string;
}
export interface GroupedAssignmentBase {
  id: string;
  clientCompanyId: string;
}

export type GroupedAssignmentBaseKeys = keyof GroupedAssignmentBase;

export type AssignmentsTableDataByRef = Record<Exclude<string, GroupedAssignmentBaseKeys>, IAssigmentsTableDataWithRequiredIds>;
export interface GroupedAssignmentsFieldsOverride extends GroupedAssignmentBase {
  overrides: IAssignmentFieldsOverride;
};
export type GroupedAssignments = GroupedAssignmentBase & AssignmentsTableDataByRef;
export type GroupedAssignmentsKey = keyof GroupedAssignmentBase | (string & {});


export type NullableGroupedAssignments = GroupedAssignments[] | undefined;

export type LayoutScreen = 'layout' | 'asignment' | 'new assignment';

export type CreateSlide = (params: {
  slideNumber: number;
  pptx: pptxgen;
  slideData: GroupedAssignments[];
  columns: number;
  isCompanyLogoVisible: boolean;
  assignmentFields: PresentationState['assignmentFields'];
  assignmentsLogoOverride: Record<string, string | undefined> | undefined;
  slideTitle: PresentationSlideTitle;
  assignmentFieldsOverride: IBaseCredentialMetaData['assignment_fields_override'];
  presentationSlideNumber: PresentationSlideNumber;
  companyOfficialLogo: CompanyOfficialLogo;
  privateAndConfidential: PrivateAndConfidential;
}) => void;

export type IGetDisplayedAssignmentLogo = (params: {
  datum: GroupedAssignments;
  assignmentsLogoOverride: IBaseCredentialMetaData['assignments_logo_override'];
  logoPreferences: ILogoPreferenceById | undefined;
}) => {
  effectiveLink: string | undefined;
  recentLogos: LogoPreference[] | null | undefined;
  defaultLogo: LogoPreference | undefined;
  userUploadedLogo: string | undefined;
}

export enum ALIGN_OPTION_VALUES {
  LEFT = "left",
  CENTER = "center",
}
